export default "__VITE_ASSET__1fRUUCWl__"